<template>
  <div class="container-fluid">
    <div class="vld-parent row pb-4 pr-0" :class="deploymentBgClass" :id="$id('calendar')" ref='calendarContainer'>

      <div
        class="col px-0 calendarWeekGrid"
        :id="$id('mainAddon')">
        <div :class="($mq == 'sm' || $mq == 'xs') ? 'container-fluid px-0' : 'container px-0'">
          <div class="row pt-4">
            <div class="col text-center">
              <h2 class="font-weight-bold">
                Additional Products Available
              </h2>

              <table class="table table-striped table-dark">
                <thead>
                  <tr>
                    <template v-if="($mq == 'xs' || $mq == 'sm')">
                      <th class="pl-1">Item</th>
                    </template>
                    <template v-else>
                      <th class="pl-1" colspan="2">Item</th>
                    </template>
                    <th class="pl-1" :style="locationChildPricing ? 'width: 230px;' : ''">Qty</th>
                    <th class="pl-1">Details</th>
                    <th class="pl-1">Price</th>
                  </tr>
                </thead>
                <tbody>

                  <tr v-for="addOn in products" :key="addOn.id">
                    <template v-if="($mq == 'xs' || $mq == 'sm')">
                      <td class="p-1" style="vertical-align: middle;">
                        <div class="row"> <!-- ITEM -->
                          <div class="col">
                            <img :alt="addOn.name" :src="addOn.imageUrl ? addOn.imageUrl : '/img/sale/product.jpg'" width="100" class="mr-2">
                          </div>
                        </div> <!-- /ITEM -->

                        <div class="row">
                          <div class="col">
                            <p class="text-shadow-highlight mb-1 heading text-tempus-blue mb-0">{{ addOn.name }}</p>
                          </div>
                        </div>
                      </td> <!-- /ITEM -->
                    </template>

                    <template v-else> <!-- ! ($mq == 'xs' || $mq == 'sm') -->
                      <td class="p-1" style="vertical-align: middle;">
                        <img :alt="addOn.name" :src="addOn.imageUrl ? addOn.imageUrl : '/img/sale/product.jpg'" width="100" class="mr-2">
                      </td> <!-- /TOOLS -->
                      <td class="p-1" style="vertical-align: middle;"> <!-- ITEM -->
                        <p class="text-shadow-highlight mb-1 heading text-tempus-blue-tint">{{ addOn.name }}</p>
                      </td> <!-- /ITEM -->
                    </template>

                    <td class="p-1" style="vertical-align: middle;"> <!-- QTY -->
                      <p class="mb-0">1</p>
                    </td> <!-- /QTY -->

                    <td class="p-1" style="vertical-align: middle;"> <!-- DETAILS -->
                      <p class="mb-0 text-left" style="font-size: 14px; line-height: 18px">{{ addOn.description }}</p>
                      <p
                        v-if="addOn.options && addOn.options.caveat"
                        v-html="addOn.options.caveat"
                        class="text-left text-pink mt-2 mb-0"
                        style="font-size: 11px; line-height: 11px">
                      </p>
                    </td> <!-- DETAILS -->

                    <td class="p-1" style="vertical-align: middle;"> <!-- PRICE -->
                      <button class="btn btn-block btn-dark-green" @click="attemptToAddProductToCart(addOn)"><span class="material-icons">add_shopping_cart</span> Add to cart for {{ addOn.sale_price | money }}
                      </button>
                    </td> <!-- /PRICE -->
                  </tr>
                </tbody>
              </table>

            </div>
          </div> <!-- .row -->

          <template v-if="showCustomerCapture">
            <h3 class="font-weight-bold mt-2 mb-4">You must add your details to start your Cart&hellip;</h3>
            <div class="form-group row">
              <label :for="$id('email')" class="col-sm-2 col-form-label pt-0"><sup class="text-red font-weight-bold" data-toggle="tooltip" title="Required">(*)</sup> Email</label>
              <div class="col-sm-10">
                <input type="email"
                  :id="$id('email')"
                  class="form-control"
                  :class="{'is-invalid': emailError}"
                  placeholder="If you have already booked before, your email will populate the rest"
                  v-model="email"
                  @blur='emailBlur'
                  autocomplete="email"
                  required>
                <div v-if="emailError" class="invalid-feedback d-block" role="alert">{{ emailError }}</div>
              </div>
            </div>

            <div class="form-group row">
              <label :for="$id('name')" class="col-sm-2 col-form-label pt-0"><sup class="text-red font-weight-bold" data-toggle="tooltip" title="Required">(*)</sup> Name</label>
              <div class="col-sm-10">
                <input type="text"
                  :id="$id('name')"
                  ref="nameInput"
                  class="form-control"
                  :class="{'is-invalid': nameError}"
                  v-model="name"
                  placeholder="Full name for booking"
                  autocomplete="name"
                  required>
                <div v-if="nameError" class="invalid-feedback d-block" role="alert">{{ nameError }}</div>
              </div>
            </div>

            <div class="form-group row" style="display: none;">
              <label :for="$id('username')" class="col-sm-2 col-form-label"><sup class="text-red font-weight-bold" data-toggle="tooltip" title="Required">(*)</sup> Username</label>
              <div class="col-sm-10">
                <input
                  type="text"
                  :id="$id('username')"
                  class="form-control"
                  v-model="username"
                  placeholder="Username"
                  autocomplete="off">
              </div>
            </div>

            <div class="form-group row">
              <label :for="$id('contactNumber')" class="col-sm-2 col-form-label pt-0">
                <sup
                  v-if="this.location.formCustomerNumberRequired"
                  class="text-red font-weight-bold"
                  data-toggle="tooltip"
                  title="Required">
                  (*)
                </sup>
                 Contact Number
               </label>
              <div class="col-sm-10">
                <input type="tel"
                  :id="$id('contactNumber')"
                  ref="customerTelephoneInput"
                  class="form-control"
                  :class="{'is-invalid': contactNumberError}"
                  v-model="contactNumber"
                  placeholder="Contact number"
                  autocomplete="tel"
                  required>
                <div v-if="contactNumberError" class="invalid-feedback d-block" role="alert">{{ contactNumberError }}</div>
              </div>
            </div>

            <div v-if="customerRequestMarketingPermission" class="form-group row">
              <div class="checkboxdiv ml-2">
                <label :for="$id('marketing_consent')">I give consent to receive additional marketing</label>
                <label class="checkboxdiv-label-md ml-2">
                  <input
                    type="checkbox"
                    :id="$id('marketing_consent')"
                    v-model="marketingConsent">
                  <span class="cr"><span class="cr-icon">&#10004;</span></span>
                </label>
              </div>
            </div>
          </template>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {Address} from 'address-rfc2821';

export default {
  props: {
    initialCart: {
      type: Object,
      required: true,
    },
    location: {
      type: Object,
      required: true,
    },
    locationChildPricing: {
      type: Boolean,
    },
    locationDiscount: {
      type: Object,
    },
    products: {
      type: Array,
    },
    customerRequestMarketingPermission: {
      type: Boolean,
    },
  },

  data() {
    return {
      cart: Vue.util.extend({}, JSON.parse(JSON.stringify(this.initialCart))),

      showCustomerCapture: false,

      email: null,
      name: null,
      username: null, // for spam detection
      contactNumber: null,
      marketingConsent: false,

      customerId: null,
      customerEmail: null,
      customerName: null,

      // validation errors
      emailError: false,
      nameError: false,
    };
  },

  computed: {
    todayDateString() {
      return moment().format('YYYY-MM-DD');
    },

    promoDate() {
      if (this.locationDiscount) {
        return moment(this.locationDiscount.date).format('YYYY-MM-DD');
      } else {
        return "N/A";
      }
    },

    deploymentBgClass() {
      switch (this.$deploymentCurrent) {
        case 'cryptology':
          return 'bg-cryptology-blue';
        case 'makeyourescape':
          return '';
        case 'coalville':
          return 'bg-lightest-gray';
        case 'escapestaging':
          return 'bg-escapestaging';
        case 'breakescape':
          return 'bg-breakescapebtn text-black';
        case 'levelup':
          return 'bg-levelup text-black';
        case 'taketheexit':
        case 'paralysis':
        case 'horrorescape':
        case 'escapegoat':
        case 'missionclassified':
        case 'rushden':
          return 'bg-darkest-gray text-white';
        case 'cypherquest':
          return 'bg-cypherquest text-white';
        case 'escaporium':
          return 'bg-black text-black';
        case 'kanyu':
        case 'beyondbreakout':
        case 'crypticescape':
        case 'escapereading':
          return 'bg-white text-black';
        case 'wisbech':
          return 'bg-wisbech text-white';
        case 'makeyourescape':
          return '';
        case 'the-real-escape':
          return 'bg-the-real-escape-bg text-white';
        case 'escapable':
          return 'bg-calendar-lighten-opacity text-white';
        default:
          return 'bg-white';
      }
    },

    contactNumberError() {
      if (this.location.formCustomerNumberRequired === false && this.contactNumber === null) {
        return null;
      } else {
        if (this.contactNumber == '***** ******') {
          return null;
        } else {
          if (this.contactNumber && this.contactNumber
            .match(/^(?:(?:\(?(?:0(?:0|11)\)?[\s-]?\(?|\+)44\)?[\s-]?(?:\(?0\)?[\s-]?)?)|(?:\(?0))(?:(?:\d{5}\)?[\s-]?\d{4,5})|(?:\d{4}\)?[\s-]?(?:\d{5}|\d{3}[\s-]?\d{3}))|(?:\d{3}\)?[\s-]?\d{3}[\s-]?\d{3,4})|(?:\d{2}\)?[\s-]?\d{4}[\s-]?\d{4}))(?:[\s-]?(?:x|ext\.?|\#)\d{3,4})?$/)
            // [3]
            // .replace(/ /g,'').match(/^((1[1-9]|2[03489]|3[0347]|5[56]|7[04-9]|8[047]|9[018])\d{8}|(1[2-9]\d|[58]00)\d{6}|8(001111|45464\d))$/)
            ) {
            return null;
          } else {
            return 'Invalid phone number.';
          }
        }
      }
    },
  },

  methods: {
    attemptToAddProductToCart(product) {
      // check if there is a customer assigned to the current cart
      if (this.cart.customer === null && this.showCustomerCapture == false) {
        this.startCustomerDetails();
        return false;
      }

      if (! this.checkCustomerDetails()) {
        flash('Customer details required to add items to Cart.', 'danger');
        this.$refs.nameInput.focus();
        return false;
      }

      if (this.customerId == null) {
        this.loading(true);
        this.searchEmail(this.email)
          .then(customerFound => {
            this.loading(false);
            if (customerFound !== null) {
              // hmm
              this.customerId = customerFound.id;
              // console.log('customer was found', this.customerId);
              this.addCustomerThenProductToCart(product);
            } else {
              this.loading(true);
              this.storeCustomer()
                .then(newCustomer => {
                  this.loading(false);
                  if (newCustomer) {
                    this.customerId = newCustomer.id;
                    if (this.fromVirtualGame) {
                      // this.makeVirtualGameSale();
                    } else {
                      // console.log('customer was stored', this.customerId);
                      this.addCustomerThenProductToCart(product);
                    }
                  } else {
                    // console.log('payButtonClicked: storeCustomerError')
                    this.payButtonDisable = false;
                    return; // some kind of error cause we failed to create the customer
                  }
                });
            }
          });
      } else {
        // Book the slot (as PENDING) this will also create a RoomSlotLock
        // console.log('book');
        this.addCustomerThenProductToCart(product);
      }
    },

    addCustomerToCart() {
      return new Promise(resolve => {
        // console.log('addCustomerToCart');

        let request = {
          location: this.location.slug,
          customer_id: this.customerId,
        }
        // console.log('request', request);

        this.loading(true);
        axios.patch(this.route('api.cart-current.update'), request)
          .then((response) => {
            // console.log('addCustomerToCart axios completed');
            this.loading(false);

            if (response.status == 200) {
              // console.log('this.cart updated', response.data);
              this.cart = response.data;
              flash('Added you as the Cart owner','success');
              resolve(true);
            } else {
              flash('Error adding Customer to Cart', 'error');
              console.log('addCustomerToCart', response.data);
              console.log('addCustomerToCart', response.status);
              console.log('addCustomerToCart', response.statusText);
              resolve(false);
            }

          })
          .catch((error) => {
            flash('Error adding RoomSlot to Cart', 'danger');
            if (error.response) {
              if (error.response.status == 422) {
                // if HTTP_UNPROCESSABLE_ENTITY some validation error laravel or us
                console.log('addCustomerToCart:422', error.response.data);
                if (error.response.data.errors) {
                  const errors = error.response.data.errors;

                  Object.keys(errors).forEach(function(key) {
                    errors[key].forEach(error => flash(error, 'danger'));
                  });
                } else {
                  flash(error.response.data, 'danger');
                }
              } else if (error.response.status == 409) {
                // else if HTTP_CONFLICT
                console.log('addCustomerToCart:409', error.response.data);
                flash(error.response.data.message, 'danger');
              } else if (error.response.status == 403) {
                // else if HTTP_FORBIDDEN on enough permissions
                console.log('addCustomerToCart:403', error.response.data);
              } else if (error.response.status == 401) {
                // else if HTTP_UNAUTHORIZED not authorized
                console.log('addCustomerToCart:401', error.response.data);
                window.location.reload();
              } else {
                console.log('addCustomerToCart: Response error', error.response.data, error.response.status, error.response.headers);
              }
            } else if (error.request) {
              // The request was made but no response was received
              // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
              // http.ClientRequest in node.js
              console.error('addCustomerToCart: Request error', error.request);
            } else {
              // Something happened in setting up the request that triggered an Error
              console.error('addCustomerToCart: Error', error.message);
            }
            this.loading(false);
            this.payButtonDisable = false;
            resolve(false);
          });
      });
    },

    async storeCustomer() {
      // console.log('storeCustomer');
      // create the customer
      let request = {
        email: this.email,
        name: this.name,
        number: this.contactNumber,
        location_id: this.location.id,
        no_mail: this.marketingConsent ? 0 : 1, // the logic is flipped as we want no_mail in the db
      }

      try {
        const response = await axios.post(this.route('api.customers.store'), request)
        if (response.status == 200) {
          return response.data;
        } else {
          flash('Error creating customer', 'danger');
          console.log('storeCustomer', response.data);
          console.log('storeCustomer', response.status);
          console.log('storeCustomer', response.statusText);
        }
      } catch (error) {
        // flash('Error creating customer', 'danger');
        if (error.response) {
          if (error.response.status == 422) {
            // if HTTP_UNPROCESSABLE_ENTITY some validation error laravel or us
            console.log('storeCustomer:422', error.response.data);
            // TODO: if The email has already been taken. ???
            if (error.response.data.errors.number) {
              this.loading(false);
              flash('Phone number invalid, cannot proceed ' + error.response.data.errors.number[0]);
             // this.contactNumberError = 'Number is invalid, please resolve.';
              this.$ref.customerTelephoneInput.focus();
            } else {
              this.loading(false);
              flash('Unable to store customer. Please check details.');
            }
          } else if (error.response.status == 409) {
            // else if HTTP_CONFLICT
            console.log('storeCustomer:409', error.response.data);
          } else if (error.response.status == 403) {
            // else if HTTP_FORBIDDEN on enough permissions
            console.log('storeCustomer:403', error.response.data);
          } else if (error.response.status == 401) {
            // else if HTTP_UNAUTHORIZED not authorized
            console.log('storeCustomer:401', error.response.data);
            window.location.reload();
          } else {
            console.log('storeCustomer: Response error', error.response.data, error.response.status, error.response.headers);
          }

        } else if (error.request) {
          // The request was made but no response was received
          // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
          // http.ClientRequest in node.js
          console.error('storeCustomer: Request error', error.request);
        } else {
          // Something happened in setting up the request that triggered an Error
          console.error('storeCustomer: Error', error.message);
        }
      }

      return null;
    },

    async addCustomerThenProductToCart(product) {
      // console.log('addRoomSlotToCart');
      // check if the cart is owned by the customer, if not, make it
      if (this.cart.customer) {
        this.addProduct(product);
      } else {
        await this.addCustomerToCart();
        this.addProduct(product);
      }
    }, // addCustomerThenProductToCart()

    addProduct(product) {
      // console.log('AddonPreChecout::addProduct', product);

      let request = {
        location: this.location.slug,
        quantity: 1,
        soldFor: product.sale_price,
        cartable: 'App\\Models\\Product:' + product.id,
      }

      var axiosRoute = this.route('api.cart-current.cart-items.store');

      // console.log('axios', axiosRoute, request);

      this.loading(true);
      axios.post(axiosRoute, request)
        .then((response) => {
          if (response.status == 200) {
            // console.log('updated', response.data);
            this.cart = response.data;

            flash('Product added to Cart', 'success');

          } else {
            flash('Error adding Product to Cart', 'error');
            console.log('addProduct', response.data);
            console.log('addProduct', response.status);
            console.log('addProduct', response.statusText);
          }

          this.loading(false);
        })
        .catch((error) => {
          flash('Error adding Product to Cart', 'danger');
          if (error.response) {
            if (error.response.status == 422) {
              // if HTTP_UNPROCESSABLE_ENTITY some validation error laravel or us
              console.log('addProduct:422', error.response.data);
              if (error.response.data.errors) {
                const errors = error.response.data.errors;

                Object.keys(errors).forEach(function(key) {
                  errors[key].forEach(error => flash(error, 'danger'));
                });
              } else {
                flash(error.response.data, 'danger');
              }
            } else if (error.response.status == 409) {
              // else if HTTP_CONFLICT
              console.log('addProduct:409', error.response.data);
              flash(error.response.data.message, 'danger');
            } else if (error.response.status == 403) {
              // else if HTTP_FORBIDDEN on enough permissions
              console.log('addProduct:403', error.response.data);
            } else if (error.response.status == 401) {
              // else if HTTP_UNAUTHORIZED not authorized
              console.log('addProduct:401', error.response.data);
              window.location.reload();
            } else {
              console.log('addProduct: Response error', error.response.data, error.response.status, error.response.headers);
            }
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            console.error('addProduct: Request error', error.request);
          } else {
            // Something happened in setting up the request that triggered an Error
            console.error('addProduct: Error', error.message);
          }
          this.loading(false);
        });
    }, // addProduct()

    startCustomerDetails() {
      // there is no customer assigned to the cart, so we need to sort this now
      this.showCustomerCapture = true;
    },

    emailBlur() {
      // console.log('emailBlur');
      if (this.customerId !== null && this.email != this.customerEmail) {
        // console.log('emailBlur:forget');
        // you changed the emil address, forgot who we though you where
        this.customerId = null;
        this.customerEmail = null;
        this.customerName = null;
      }

      if (this.email && (this.name == null || this.name == '')) {

        this.emailError = false;

        try {
          new Address(this.email);
        } catch (error) {
          this.emailError = error.message; // Please enter a valid email address.
          return;
        }
        // console.log('emailBlur:pre searchEmail');
        this.loading(true, this.$refs.bookModal);
        this.searchEmail(this.email)
          .then(customerFound => {
            this.loading(false);
            if (customerFound !== null) {
              this.customerId = customerFound.id;
              this.customerEmail = this.email;
              this.customerName = customerFound.name;
              this.name = this.customerName;
              this.contactNumber = '***** ******';
              this.marketingConsent = ! customerFound.no_mail;
            } else {
              this.$refs.nameInput.focus();
            }
          });
      }
    },

    async searchEmail(emailToSearch) {
      let request = {
        email: emailToSearch,
      }

      try {
        const response = await axios.post(this.route('api.customers.email-lookup'), request);
        if (response.status == 200) {
          return response.data;
        }
      } catch (error) {
        if (error.response) {
          if (error.response.status == 422) { // HTTP_UNPROCESSABLE_ENTITY some validation error laravel or us
            this.emailError = error.response.data.errors.email[0]; // Please enter a valid email address.
          } else if (error.response.status == 404) {
            this.customerId = null;
            this.customerEmail = null;
            this.customerName = null;
          }
          // console.log('emailBlur: Response error', error.response.data, error.response.status, error.response.headers);
        } else if (error.request) {
          // The request was made but no response was received
          // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
          // http.ClientRequest in node.js
          // console.error('emailBlur: Request error', error.request);
        } else {
          // Something happened in setting up the request that triggered an Error
          // console.error('emailBlur: Error', error.message);
        }
      }

      return null;
    },

    checkCustomerDetails() {
      if (this.email == null || this.email == '') {
        this.emailError = 'An email address is required.'; // Please enter a valid email address.
      } else {
        this.emailError = false;

        try {
          new Address(this.email);
        } catch (error) {
          this.emailError = error.message; // Please enter a valid email address.
        }

        // TODO: try looking up the email again?
        this.loading(true);
        this.searchEmail(this.email)
          .then(customerFound => {
            this.loading(false);
            if (customerFound !== null) {
              // LWK what to do?
              this.customerId = customerFound.id;

              if (this.name != customerFound.name || this.contactNumber != '***** ******') {
                // should we update the Customer details?
                // this.updateCustomer();
              }
            }
          });
      }

      if (this.name == null || this.name == '') {
        this.nameError = 'Please enter your name.';
      } else {
        this.nameError = false;
      }

      if (this.location.formCustomerNumberRequired && this.contactNumberError !== null) {
        this.numberError = 'Please enter a valid number.';
      } else {
        this.numberError = false;
      }

      if (this.emailError
        || this.nameError
        || this.numberError) {
        return false;
      }

      return true;
    },

    cartRefreshed(cart) {
      // console.log('cartRefreshed', cart);
      this.cart = cart;
    }, // cartRefreshed()

    /* ===============
     * Echo methods
     */

    echoInitCart() {
      if (! process.env.MIX_PUSHER_APP_KEY) {
        return;
      }

      Echo.channel('cart.session.' + this.cart.session)
        .listen('Cart.CartSaved', this.cartSavedEvent);
    },

    echoDeInitCart() {
      if (! process.env.MIX_PUSHER_APP_KEY) {
        return;
      }

      Echo.leave('cart.session.' + this.cart.session);
    },

    cartSavedEvent(event) {
      console.log('cartSavedEvent(event)', event);
      this.cart = event.cart;
    },

    /*
     * END Echo methods
     * =============== */

    range(start, end) { // this is for a v-for, it cannot not start at 0, vueIdiots
      return Array(end - start + 1).fill().map((_, idx) => start + idx);
    },
  },

  mounted() {
    this.$nextTick(() => {
      this.echoInitCart();
    });

  },

  beforeDestroy() {
    this.echoDeInitCart();
  },
}
</script>
